import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import { saveChanges } from "./save-changes";

const REENTRY = ["never", "once_per_purchase", "every_time"];

export const DefaultPanel = () => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key) => t(`emailAutomations.builder.panel.${key}`);
  const items = [
    ["email", "emailBody"],
    ["delay", "delayBody"],
    ["filter", "filterBody"],
  ];
  return (
    <div className="ab-panel">
      <h3>{tr("title")}</h3>
      <p className="ab-panel__sub">{tr("subtitle")}</p>
      <div className="ab-panel__empty">
        <span className="ab-panel__icon" aria-hidden="true">
          <img src="/img/new-icons/automation-flow.svg" alt="" />
        </span>
        <strong>{tr("emptyTitle")}</strong>
        <span>{tr("emptyBody")}</span>
      </div>
      <h4 className="ab-panel__heading">{tr("whatYouCanAdd")}</h4>
      <ul className="ab-addable">
        {items.map(([type, bodyKey]) => (
          <li key={type}>
            <span className={`ab-addable__icon ab-addable__icon--${type}`}>
              <SvgIcon
                src={`/img/new-icons/step-${type}.svg`}
                useCurrentColor
              />
            </span>
            <div>
              <strong>{t(`emailAutomations.builder.add.${type}`)}</strong>
              <span>{tr(bodyKey)}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const ExitRulesPanel = ({ automation, exitEvents, closeHref }) => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key, params) =>
    t(`emailAutomations.builder.exitPanel.${key}`, params);
  const [events, setEvents] = useState(
    automation.exitRules.map((rule) => rule.event)
  );
  const [reentry, setReentry] = useState(automation.reentry);

  const toggle = (event) =>
    setEvents((current) =>
      current.includes(event)
        ? current.filter((item) => item !== event)
        : [...current, event]
    );

  return (
    <div className="ab-panel">
      <h3>{tr("title")}</h3>
      <p className="ab-panel__sub">{tr("intro")}</p>

      <h4 className="ab-panel__heading">{tr("stopWhen")}</h4>
      <fieldset className="ab-checks">
        <legend className="sr-only">{tr("stopWhen")}</legend>
        {exitEvents.map((event) => (
          <label key={event} className="ab-check">
            <input
              type="checkbox"
              className="sr-only"
              checked={events.includes(event)}
              onChange={() => toggle(event)}
            />
            <i aria-hidden="true" />
            <span>{tr(`events.${event}`)}</span>
          </label>
        ))}
      </fieldset>

      <h4 className="ab-panel__heading">{tr("reentry")}</h4>
      <p className="ab-panel__sub">{tr("reentryIntro")}</p>
      <fieldset className="ea-choices">
        <legend className="sr-only">{tr("reentry")}</legend>
        {REENTRY.map((option) => (
          <label
            key={option}
            className={`ea-choice${reentry === option ? " ea-choice--selected" : ""}`}
          >
            <input
              type="radio"
              name="reentry"
              className="sr-only"
              value={option}
              checked={reentry === option}
              onChange={() => setReentry(option)}
            />
            <i className="ea-choice__radio" aria-hidden="true" />
            <strong>{tr(`options.${option}.title`)}</strong>
            <span>{tr(`options.${option}.body`)}</span>
          </label>
        ))}
      </fieldset>
      <p className="ab-warning">{tr("warning")}</p>

      <div className="ab-panel__actions">
        {/* biome-ignore lint/a11y/useSemanticElements: a real link so Rill navigates; role only picks up button styles */}
        <a //NOSONAR
          href={closeHref}
          className="ep-cancel"
          role="button"
          data-button-type="secondary"
          data-action="cancel"
        >
          {tr("cancel")}
        </a>
        <button
          type="button"
          data-button-type="primary"
          onClick={() =>
            saveChanges(automation._id, {
              exitRules: events.map((event) => ({ event })),
              reentry,
            })
          }
        >
          {tr("save")}
        </button>
      </div>
    </div>
  );
};

ExitRulesPanel.propTypes = {
  automation: PropTypes.object.isRequired,
  exitEvents: PropTypes.arrayOf(PropTypes.string).isRequired,
  closeHref: PropTypes.string.isRequired,
};
